var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0243 3.17468C13.3324 -0.517251 7.36686 -0.517251 3.67493 3.17468C-0.0170067 6.86662 -0.0170067 12.8321 3.67493 16.524C7.36686 20.216 13.3324 20.216 17.0243 16.524C20.7162 12.8321 20.7162 6.86662 17.0243 3.17468ZM12.3103 13.0616L10.3288 11.08L8.34721 13.0616L7.11656 11.8309L9.09811 9.84936L7.11656 7.86782L8.3472 6.63717L10.3288 8.61872L12.3103 6.63717L13.5409 7.86782L11.5594 9.84937L13.5409 11.8309L12.3103 13.0616Z",
    fill: "#FF6363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBtnIcon);
export default __webpack_public_path__ + "static/media/cross-btn-icon.5892b7c54e777a9cd762161b306d2596.svg";
export { ForwardRef as ReactComponent };